import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopOccupationsBySectors = async (urlDataAPI:any) => {
    const { exportType, hubIds, sectorIds, locations, fromTimeline, toTimeline, isEntryLevel } = urlDataAPI;
    const { path, method } = endpoints.occupationAndSector.exportTopOccupationsBySectors;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds, ISICCodes: sectorIds, locations, fromQuarter: fromTimeline, toQuarter: toTimeline, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};